import React, { Component } from "react";
import Logout from "../images/logout.svg";
import Profilee from "../images/profile.svg";
import Back from "../images/back.svg";
import menu from "../images/menu.svg";
import report from "../images/report.svg";
import users from "../images/users.png";
import loyalty from "../images/loyalty.png";
import subscription from "../images/subscription.png";
import routin from "../images/routinicon.png";
import settingIcon from "../assets/setting.png";
import kitchen from "../images/kitchenicon.png";
import cachier from "../images/cachier.png";
import manager from "../images/manager.png";
import garson from "../images/garson.png";
import messages from "../assets/messages.png";
import qrcode from "../images/qrcode.svg";
import orders from "../images/orders.svg";
import DashboardItem from "../components/DashboardItem";
import Loading from "../components/Loading";
import { Modal } from "react-bootstrap";
import Profile from "./Profile";
import setting from "../assets/setting.svg";
import { NumericFormat } from "react-number-format";
import CustomButton from "../components/CustomButton";
import Cancel from "../assets/cancel.svg";
import Tick from "../assets/tick.svg";
import { WhisperSpinner } from "react-spinners-kit";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import ListViewer from "../components/ListViewer";
import { toast } from "react-toastify";
import {
  BaseUrl,
  Authorization,
  BaseUrlPublic,
  isUser,
  LogoutFunction,
} from "../static.js";
import Tooltip from "@mui/material/Tooltip";
import { useStore } from "../store";

export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      resName: "",
      resDescription: "",
      resID: null,
      notFound: false,
      ModalShow: false,
      modalType: "",
      taxErrorText: "",
      taxValue: "",
      taxFixed: false,
      serviceErrorText: "",
      serviceValue: "",
      packing: false,
      packingFixed: true,
      fixedPriceErrorText: "",
      fixedPriceValue: 0,
      tax: false,
      service: false,
      ModalShow2: false,
      currentListTypeIsGroup1: false,
      groupList1: [],
      groupList2: [],
      currentList: [],
      listLoading: false,
      defaultLangId: 0,
      subscriptionType: 0,
      butArray: [],
      butoArray: [],
      FullNameValue: "",
    };
  }

  // checkToken(){
  //   let data = {
  //     businessCode: localStorage.getItem("code"),
  //   };

  //   data = Object.assign(data, Authorization());

  //   fetch(BaseUrl + "checkToken", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify(data),
  //   })
  //     .then((res) => res.json())
  //     .then((result) => {
  //       console.log("checkToken: ", result);
  //       if (result.status === 200) {
  //         this.setState({
  //           serverResponse: true,
  //           butArray: isUser ? result.butArray : [],
  //           butoArray: isUser ? result.butoArray : [],
  //           subscriptionType: result.subscriptionType,
  //         });
  //       } else if (result.status===401) {
  //         LogoutFunction();
  //       }else{

  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // }

  componentDidMount() {
    if (this.props.match.params.id.toLowerCase().trim() === "createnew") {
      this.setState({ notFound: true });
      return;
    }

    let data = {
      businessCode: this.props.match.params.id,
    };

    data = Object.assign(data, Authorization());

    console.log(data);
    fetch(BaseUrl + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          if (result.result[0].subscriptionType === 3) {
            toast.error("اشتراک رستوران مورد نظر به پایان رسیده است", {
              position: toast.POSITION.BOTTOM_RIGHT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
            this.props.goToBusinessList();
            return;
          }
          let name = "";
          let des = "";
          let defaultLangId = 0;
          result.info.forEach((element) => {
            if (element.languageId === 1) {
              name = element.name;
              des = element.descr;
              defaultLangId = element.languageId;
            }
          });

          if (name === "") {
            result.info.forEach((element) => {
              if (element.languageId === result.result[0].defaultLanguage) {
                name = element.name;
                des = element.descr;
                defaultLangId = element.languageId;
              }
            });
          }

          if (name === "") {
            result.info.forEach((element) => {
              if (name === "") {
                name = element.name;
                des = element.descr;
                defaultLangId = element.languageId;
              }
            });
          }

          this.setState(
            {
              resID: result.result[0].id,
              resName: name,
              resDescription: des,
              defaultLangId: defaultLangId,
              butArray: result.butArray,
              butoArray: result.butoArray,
              subscriptionType:
                result.result[0].subscriptionType === 1
                  ? 6
                  : result.result[0].subscriptionType,
            },
            () => {
              useStore.setState({
                subscriptionType: this.state.subscriptionType,
              });
              if (isUser) this.readPersonalInfo();
              else this.setState({ loading: false });
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          this.props.goToBusinessList();
        }
        // console.log("findBusinessWithCode:", result);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  readPersonalInfo() {
    let data = { businessCode: this.props.match.params.id };
    data = Object.assign(data, Authorization());
    console.log(data);
    fetch(BaseUrl + "readPersonalInfo", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result.result);
        if (result.status === 200) {
          this.setState({
            loading: false,
            FullNameValue: result.result[0].fullName
              ? result.result[0].fullName
              : result.result[0].userName,
          });
        } else if (result.status === 401) {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onBack() {
    this.props.history.push("/Restaurants");
  }

  onMenuClick() {
    this.props.onMenuClick(this.props.match.params.id);
  }

  onOrdersClick() {
    this.props.onOrdersClick(this.props.match.params.id);
  }

  onCashierClick() {
    this.props.onCashierClick(this.props.match.params.id);
  }

  onQRCodeClick() {
    this.props.onQRCodeClick(this.props.match.params.id);
  }

  onUsersClick() {
    this.props.onUsersClick(this.props.match.params.id);
  }

  onReportClick() {
    this.props.onReportClick(this.props.match.params.id);
  }

  onClubClick() {
    this.props.onClubClick(this.props.match.params.id);
  }

  onSubscriptionClick() {
    this.props.onSubscriptionClick(this.props.match.params.id);
  }

  onBuySmsClick() {
    this.props.onBuySmsClick(this.props.match.params.id);
  }

  onOrderRoutinesClick() {
    this.props.onOrderRoutinesClick(this.props.match.params.id);
  }

  onSettingClick() {
    this.props.onSettingClick(this.props.match.params.id);
  }

  onMyOrderClick(type) {
    this.props.onMyOrderClick(this.props.match.params.id, type);
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  onLogout() {
    LogoutFunction();
  }

  onProfile() {
    this.setState({ ModalShow: true, modalType: "profile" });
  }

  hideModal2() {
    this.setState({ ModalShow2: false });
  }

  onSelectCategory1() {
    this.setState(
      {
        ModalShow2: true,
        listLoading: true,
        currentListTypeIsGroup1: true,
        currentList: [],
      },
      () => {
        this.getMenu();
      }
    );
  }

  onSelectCategory2() {
    this.setState(
      {
        ModalShow2: true,
        listLoading: true,
        currentListTypeIsGroup1: false,
        currentList: [],
      },
      () => {
        this.getMenu();
      }
    );
  }

  getMenu() {
    let data = {
      languageId: this.state.defaultLangId,
      type: "getMenuWithBusinessCode",
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    // console.log(data);

    fetch(BaseUrl + "getMenu", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        // console.log("getMenuuuuuu:", result);
        let menu = [...result.result];
        let menucat = [];
        for (let i = menu.length - 1; i >= 0; i--) {
          menu[i].nameObj.forEach((element) => {
            if (element.languageId === 1) {
              menu[i].name = element.name;
            }

            if (
              !menu[i].name &&
              element.languageId === this.state.defaultLangId
            ) {
              menu[i].name = element.name;
            }

            if (!menu[i].name) {
              menu[i].name = element.name;
            }
          });

          menucat.push(menu[i]);
        }

        // console.log(menucat);

        this.setState({
          listLoading: false,
          currentList: menucat,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onConfirmGroups(list) {
    if (this.state.currentListTypeIsGroup1)
      this.setState({ groupList1: list, ModalShow2: false });
    else {
      let cat = [];
      list.forEach((element) => {
        cat.push({
          categoryId: element.id,
          packingPrice: Number(element.packingPrice),
        });
      });
      this.setState({ groupList2: cat, ModalShow2: false });
    }
  }

  render() {
    // const setBusinessCode = useStore((state) => state.setBusinessCode);
    if (!this.state.loading) {
      return (
        <div className="Login">
          <div className="header">
            {!isUser && (
              <div
                onClick={this.onBack.bind(this)}
                // onClick={() => {
                //   useStore.setState({ businessCode: "true" });
                // }}
                className="linkStyle backButton"
              >
                <img
                  src={Back}
                  alt=""
                  className="backButtonIcon"
                  style={{ transform: "rotate(180deg)" }}
                />
                لیست رستوران‌ها
              </div>
            )}
            {isUser && <div />}
            {/* <div onClick={this.onLogout.bind(this)} className="linkStyle backButton"><img src={Logout} alt="" className="backButtonIcon" />Logout</div> */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                height: "fit-content",
                alignItems: "center",
              }}
            >
              <Tooltip title="اطلاعات کاربری">
                <div
                  onClick={this.onProfile.bind(this)}
                  className="linkStyle backButton"
                  // data-tip="اطلاعات کاربری"
                  // data-place="right"
                >
                  <img src={Profilee} alt="" className="backButtonIcon" />
                </div>
              </Tooltip>
              {/* {!isUser && (
                <div
                  onClick={this.onSetting.bind(this)}
                  className="linkStyle backButton"
                  data-tip="تنظیمات"
                  data-place="right"
                >
                  <img src={setting} alt="" className="backButtonIcon" />
                </div>
              )} */}
              <div
                style={{
                  height: "20px",
                  minWidth: "1px",
                  backgroundColor: "var(--brown1)",
                  margin: "0px 5px",
                }}
              />
              <Tooltip title="خروج">
                <div
                  onClick={this.onLogout.bind(this)}
                  className="linkStyle backButton"
                  // data-tip="خروج"
                  // data-place="bottom"
                >
                  <img src={Logout} alt="" className="backButtonIcon" />
                </div>
              </Tooltip>
            </div>
          </div>
          <div className="LoginContent">
            <div className="RestaurantsListTitle">{this.state.resName}</div>
            {isUser ? (
              <div className="RestaurantsListSubTitle">
                {/* {localStorage.getItem("userName")} */}
                {this.state.FullNameValue}
              </div>
            ) : (
              <div className="RestaurantsListSubTitle">
                {this.state.resDescription}
              </div>
            )}
          </div>
          <div
            style={{ minHeight: "30px", height: "8vh", maxHeight: "60px" }}
          />
          <div className="dashboardContent">
            <div
              style={{
                flex: "1",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="menu-grid">
                {isUser && this.state.butArray.indexOf(1) > -1 && (
                  <DashboardItem
                    img={manager}
                    title="مدیر داخلی"
                    description="مشاهده سفارشات مربوطه به شما"
                    onClick={this.onMyOrderClick.bind(this, "Manager")}
                  />
                )}

                {isUser && this.state.butArray.indexOf(2) > -1 && (
                  <DashboardItem
                    img={cachier}
                    title="صندوق‌دار"
                    description="مشاهده سفارشات مربوطه به شما"
                    onClick={this.onMyOrderClick.bind(this, "Cashier")}
                  />
                )}

                {isUser && this.state.butArray.indexOf(3) > -1 && (
                  <DashboardItem
                    img={garson}
                    title="گارسون"
                    description="مشاهده سفارشات مربوطه به شما"
                    onClick={this.onMyOrderClick.bind(this, "Waiter")}
                  />
                )}

                {isUser && this.state.butArray.indexOf(4) > -1 && (
                  <DashboardItem
                    img={kitchen}
                    title="آشپزخانه"
                    description="مشاهده سفارشات مربوطه به شما"
                    onClick={this.onMyOrderClick.bind(this, "KDS")}
                  />
                )}

                {((isUser &&
                  (this.state.butArray.indexOf(1) > -1 ||
                    this.state.butArray.indexOf(2) > -1 ||
                    this.state.butArray.indexOf(3) > -1)) ||
                  !isUser) &&
                  this.state.subscriptionType !== 3 &&
                  this.state.subscriptionType !== 4 && (
                    <DashboardItem
                      img={cachier}
                      title="صندوق"
                      description="ثبت سفارشات مشتری"
                      onClick={this.onCashierClick.bind(this)}
                    />
                  )}

                {((isUser &&
                  (this.state.butArray.indexOf(1) > -1 ||
                    this.state.butArray.indexOf(2) > -1 ||
                    this.state.butArray.indexOf(3) > -1)) ||
                  !isUser) &&
                  this.state.subscriptionType !== 3 &&
                  this.state.subscriptionType !== 4 && (
                    <DashboardItem
                      img={orders}
                      title="سفارشات"
                      description="مشاهده سفارشات موجود"
                      onClick={this.onOrdersClick.bind(this)}
                    />
                  )}
                {((isUser &&
                  (this.state.butArray.indexOf(1) > -1 ||
                    this.state.butArray.indexOf(2) > -1 ||
                    this.state.butArray.indexOf(3) > -1)) ||
                  !isUser) && (
                  <DashboardItem
                    img={menu}
                    title="منو"
                    description="منوی رستوران خودتو بساز"
                    onClick={this.onMenuClick.bind(this)}
                  />
                )}
                {((isUser &&
                  (this.state.butArray.indexOf(1) > -1 ||
                    this.state.butArray.indexOf(2) > -1 ||
                    this.state.butArray.indexOf(3) > -1)) ||
                  !isUser) &&
                  this.state.subscriptionType !== 3 && (
                    <DashboardItem
                      img={qrcode}
                      title="QR Code"
                      description="ایجاد کد تصویری برای میز یا دستگاه سفارشگیر"
                      onClick={this.onQRCodeClick.bind(this)}
                    />
                  )}
                {((isUser &&
                  this.state.butArray.indexOf(1) > -1 &&
                  this.state.subscriptionType !== 3 &&
                  this.state.subscriptionType !== 4) ||
                  !isUser) &&
                  this.state.subscriptionType !== 3 &&
                  this.state.subscriptionType !== 4 && (
                    <DashboardItem
                      img={users}
                      title="کاربران"
                      description="ایجاد کابر جدید و اختصاص سطح دسترسی"
                      onClick={this.onUsersClick.bind(this)}
                    />
                  )}

                {((isUser &&
                  this.state.butoArray.indexOf(3) > -1 &&
                  this.state.subscriptionType !== 3 &&
                  this.state.subscriptionType !== 4) ||
                  !isUser) &&
                  this.state.subscriptionType !== 3 &&
                  this.state.subscriptionType !== 4 && (
                    <DashboardItem
                      img={routin}
                      title="روال سفارش"
                      description="تعریف روند و گام‌های سفارش، از ثبت سفارش تا تحویل به مشتری"
                      onClick={this.onOrderRoutinesClick.bind(this)}
                    />
                  )}

                {!isUser && this.state.subscriptionType === 6 && (
                  <DashboardItem
                    img={loyalty}
                    title="باشگاه مشتریان"
                    description="گزارش خلاصه عملکردهای رستوران"
                    onClick={this.onClubClick.bind(this)}
                  />
                )}
                {((isUser && this.state.butArray.indexOf(1) > -1) ||
                  !isUser) && (
                  <DashboardItem
                    img={subscription}
                    title="اشتراک"
                    description="خرید یا تمدید اشتراک"
                    onClick={this.onSubscriptionClick.bind(this)}
                  />
                )}
                {((isUser &&
                  this.state.butArray.indexOf(1) > -1 &&
                  this.state.subscriptionType !== 3 &&
                  this.state.subscriptionType !== 4) ||
                  !isUser) &&
                  this.state.subscriptionType !== 3 &&
                  this.state.subscriptionType !== 4 && (
                    <DashboardItem
                      img={messages}
                      title="بسته پیامک"
                      description="خرید یا تمدید بسته پیامک"
                      onClick={this.onBuySmsClick.bind(this)}
                    />
                  )}

                {((isUser &&
                  this.state.butArray.indexOf(1) > -1 &&
                  this.state.subscriptionType !== 3 &&
                  this.state.subscriptionType !== 4) ||
                  !isUser) &&
                  this.state.subscriptionType !== 3 &&
                  this.state.subscriptionType !== 4 && (
                    <DashboardItem
                      img={report}
                      title="گزارشات"
                      description="گزارش خلاصه عملکردهای رستوران"
                      onClick={this.onReportClick.bind(this)}
                    />
                  )}

                {((isUser &&
                  (this.state.butArray.indexOf(1) > -1 ||
                    this.state.butArray.indexOf(2) > -1) &&
                  this.state.subscriptionType !== 3 &&
                  this.state.subscriptionType !== 4) ||
                  !isUser) &&
                  this.state.subscriptionType !== 3 &&
                  this.state.subscriptionType !== 4 && (
                    <DashboardItem
                      img={settingIcon}
                      title="تنظیمات"
                      description="مالی و درگاه پرداخت"
                      onClick={this.onSettingClick.bind(this)}
                    />
                  )}
              </div>
            </div>
            <div style={{ flex: "2" }} />
          </div>
          <Modal
            show={this.state.ModalShow2}
            animation={true}
            size="md"
            backdrop="static"
            backdropClassName="backdropClassName"
            onHide={this.hideModal2.bind(this)}
            centered
          >
            {this.state.ModalShow2 && (
              <ListViewer
                withPrice={!this.state.currentListTypeIsGroup1}
                withPercent={this.state.currentListTypeIsGroup1}
                groups={this.state.currentListTypeIsGroup1}
                currentSelected={
                  this.state.currentListTypeIsGroup1
                    ? this.state.groupList1
                    : this.state.groupList2
                }
                list={this.state.currentList}
                loading={this.state.listLoading}
                listType="group"
                // onConfirmProduct={this.onConfirmProduct.bind(this)}
                onConfirmGroups={this.onConfirmGroups.bind(this)}
                hideModal={this.hideModal2.bind(this)}
              />
            )}
          </Modal>

          <Modal
            show={this.state.ModalShow}
            animation={false}
            onHide={this.hideModal.bind(this)}
            centered
          >
            <Profile
              businessCode={this.props.match.params.id}
              hideModal={this.hideModal.bind(this)}
            />
          </Modal>
        </div>
      );
    } else {
      if (this.state.notFound) {
        return null;
      } else {
        return <Loading />;
      }
    }
  }
}
